import { render, staticRenderFns } from "./Bahn1ImpulseNew.vue?vue&type=template&id=230e576a&scoped=true&"
import script from "./Bahn1ImpulseNew.vue?vue&type=script&lang=js&"
export * from "./Bahn1ImpulseNew.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1ImpulseNew.vue?vue&type=style&index=0&id=230e576a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e576a",
  null
  
)

export default component.exports